import { defineStore } from 'pinia';
import { COOKIES } from '~/helpers/constants';


export const useCoveoStore = defineStore('coveo-store', {
    state: () => ({
        authToken: "no token value",
        tokenEnvironment: "no token environment",
        tokenExpirationDate: null,
    }),
    actions: {
        setAuthToken(token: string): void {
            this.authToken = token;
            // Set token expiration date to 24 hours from now
            this.setTokenExpirationDate(Date.now() + 24 * 60 * 60 * 1000);
        },
        async renewAccessToken(context): Promise<string> {
            const coveoVisitorId = context.app.$cookies.get(COOKIES.COVEO_VISITOR_ID);
            const response = await context.app.$vsf.$coveo.api.auth({name: coveoVisitorId});
            const token: string = response?.[0]?.token;
            this.setAuthToken(token);
            return token;
        },
        setTokenExpirationDate(date: number): void {
            this.tokenExpirationDate = date;
        }
    },
    getters: {
        getAuthToken: (state): string => {
            return state.authToken;
        },
        getTokenExpirationDate: (state): number => {
            return state.tokenExpirationDate;
        },
        getTokenEnvironment: (state): string => {
            return state.tokenEnvironment;
        }
    }
});
